import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-generic-modal',
    template: `
    <p-dialog
      [(visible)]="visible"
      [modal]="true"
      [dismissableMask]="dismissableMask"
      [style]="{ width: width }"
      [contentStyle]="contentStyle"
      [breakpoints]="breakpoints"
      [showHeader]="showHeader"
      [header]="header"
      (onHide)="onHide.emit()"
      [styleClass]="styleClass"
    >
      <ng-content></ng-content>
    </p-dialog>
  `
})
export class GenericModalComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<void>();

    @Input() header = '';
    @Input() width = '500px';
    @Input() contentStyle: any = {};
    @Input() breakpoints: any = { '768px': '380px', '410px': '90vw' };
    @Input() dismissableMask = true;
    @Input() showHeader = false;
    @Input() styleClass: any= '';
}
